import PropTypes from 'prop-types';
import React from 'react';

import styles from '../Page.module.scss';

function ClickableItem({
  children, url, onClick,
}) {
  return (
    <div>
      {
        url
          ? (
            <a
              className={styles.clickable}
              href={url}
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {children}
            </a>
          )
          : (
            <div
              className={styles.clickable}
              onClick={onClick}
              onKeyPress={() => {}}
              role="button"
              tabIndex="-1"
            >
              {children}
            </div>
          )
      }
      <hr />
    </div>
  );
}

ClickableItem.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string,
  onClick: PropTypes.func,
};

ClickableItem.defaultProps = {
  onClick: () => {},
  url: '',
};

export default ClickableItem;
